(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminDuplicationFactors', {
                requireLogin: true,
                url: 'admin/duplicationFactors',
                templateUrl: 'app/admin/duplicationFactors/duplicationFactors.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator'],
                    navMarker: ['admin', 'duplicationFactors']
                },
                controller: 'duplicationFactorsCtrl'
            })
        }]);
})();